/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
 */
import { deliveryExecutionStatuses } from '../session/sessionStates.js';

/**
 * isPausedByProctorSession:
 * [postponed if 'transition]      [socket pause]<======================>[socket resume]
 *
 * isPausedByProctorUiFlow:
 * [postponed if transition]      ['ProctorWait' screen + feedback]<===========[user closes feedback]========>[user closes 'ProctorWait' screen]
 */

/**
 * Reflects 'true' paused state, corresponding to events from backend;
 * But in case if postponed event handling during transitions it will also be postponed
 * @param {Object} testContext
 * @returns {Boolean}
 */
export function isPausedByProctorExecution(testContext) {
    return testContext.status === deliveryExecutionStatuses.suspended;
}

/**
 * Update 'true' paused state, corresponding to events from backend;
 * But in case if postponed event handling during transitions it will also be postponed.
 * @param {Object} testContext
 * @param {Boolean} paused
 * @returns {Object} same updated testContext
 */
export function updatePausedByProctorExecution(testContext, paused) {
    testContext.status = paused ? deliveryExecutionStatuses.suspended : deliveryExecutionStatuses.interacting;
    return testContext;
}

/**
 * Reflects UI paused state: resume event may already be received, but we still show feedback, or still show ProctorWait screen
 * Is updated by testRunner.pause() and testRunner.resume(). Listen to `pause` and `resume` testRunner events to subscribe to its change.
 * Equals `testSessionStatus.proctorwait`.
 * @param {Object} testRunner
 * @returns {Boolean}
 */
export function isPausedByProctorUiFlow(testRunner) {
    return Boolean(testRunner.getState('pause'));
}

/**
 * Is proctoring functionality enabled for this test
 * (= was it launched using proctoring tool)
 * @param {*} testContext
 * @returns {Boolean}
 */
export function isProctoredSession(testContext) {
    return testContext.isProctored;
}
